import React, { useState, useEffect } from 'react'
import '../../Style/Table4.css'
import MaterialTable from 'material-table'
// import AddIcon from '@material-ui/icons/Add'
import { Grid } from '@material-ui/core'
// import { getAdaptationMeasuresByForm } from '../../../../../services/Elegibilidad/get'
// import { useFormElegibilidad } from '../../../../../context/ElegibilidadContext'
import { useEligibility } from '../../../../../../context/EligibilityContext'
import { getAdaptationMeasuresByForm } from '../../../../../../services/Elegibilidad/get'
import NumberFormat from 'react-number-format'

const Table52 = ({ idElegibilityForm }) => {
  const [state] = useEligibility()

  const [tableData, setTableData] = useState([])

  const getDataTable = async () => {
    try {
      const response = await getAdaptationMeasuresByForm(idElegibilityForm)
      if (response.Code === 200) {
        setTableData(response.Data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (
      state.step === 5 &&
      idElegibilityForm !== undefined &&
      idElegibilityForm !== null &&
      tableData.length === 0
    ) {
      getDataTable()
    }
  }, [state.step])

  const columns = [
    {
      title: 'Tecnología de adaptación',
      field: 'TechnologyDetail',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Si',
      field: 'IsImplemented',
      filterPlaceholder: 'filter',
      type: 'boolean',
    },
    {
      title: 'Justificación',
      field: 'Justification',
      align: 'center',
      grouping: false,
    },
    {
      title: 'Requerido como parte del subproyecto',
      field: 'IsRequired',
      align: 'center',
      grouping: false,
      type: 'boolean',
    },
    {
      title: 'Área de tierra a mejorar con medida de adaptación (Ha)',
      field: 'LandAreaToImprove',
      align: 'center',
      grouping: false,
      render: (expense) => (
        <NumberFormat
          value={expense.LandAreaToImprove}
          thousandSeparator={true}
          decimalScale={2}
          displayType={'text'}
          isNumericString={true}
          fixedDecimalScale
        />
      ),
    },
    {
      title:
        'Número de agricultores que se espera que adopten la medida de adaptación',
      field: 'agriculturistNumber',
      align: 'center',
      grouping: false,
      type: 'numeric',
    },
  ]
  return (
    <div className="App">
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={tableData}
            onSelectionChange={(selectedRows) => console.log(selectedRows)}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              filtering: false,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'both',

              exportFileName: 'TableData',
              addRowPosition: 'first',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              // toolbarButtonAlignment: 'left',
              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),
              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=""
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default React.memo(Table52)
